import React, { useState, useEffect } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Stepper,
    Step,
    StepLabel,
    Box,
} from '@mui/material';
import RequestService from '../../services/RequestService';
import QuizForm from './QuizForm';

const EditQuizDialog = ({ open, onClose, onSuccess, user, quizId }) => {
    const [formData, setFormData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [games, setGames] = useState([]);
    const [groups, setGroups] = useState([]);
    const [activeStep, setActiveStep] = useState(0);
    const steps = ['Informações', 'Destino', 'Perguntas', 'Revisão'];

    useEffect(() => {
        if (open && quizId) {
            const fetchQuiz = async () => {
                try {
                    const quiz = await RequestService.getQuizById(quizId);
                    setFormData({
                        title: quiz.title,
                        description: quiz.description,
                        maxAttempts: quiz.maxAttempts,
                        secondsPerQuestion: quiz.secondsPerQuestion,
                        xp: quiz.xp,
                        coin: quiz.coin,
                        isLimitedTime: quiz.isLimitedTime,
                        startDate: quiz.startDate || '',
                        endDate: quiz.endDate || '',
                        entireGame: quiz.entireGame,
                        gameIds: quiz.gameIds || [],
                        groupIds: quiz.groupIds || [],
                        questions: quiz.questions.map((q) => ({
                            id: q.id,
                            title: q.title,
                            position: q.position,
                            coin: q.coin,
                            options: q.options.map((opt) => ({
                                id: opt.id,
                                text: opt.text,
                                correct: opt.isCorrect,
                            })),
                        })),
                    });
                    setLoading(false);
                } catch (err) {
                    console.error('Erro ao carregar quiz:', err);
                }
            };
            fetchQuiz();
        }
    }, [open, quizId]);

    useEffect(() => {
        if (open) {
            const fetchLists = async () => {
                try {
                    const gamesData = await RequestService.getGames(
                        user.company.id
                    );
                    const groupsData = await RequestService.getGroups(
                        user.company.id
                    );
                    setGames(Array.isArray(gamesData) ? gamesData : []);
                    setGroups(Array.isArray(groupsData) ? groupsData : []);
                } catch (err) {
                    console.error('Erro ao carregar jogos/grupos:', err);
                }
            };
            fetchLists();
        }
    }, [open, user.company.id]);

    const handleSubmit = async () => {
        try {
            const payload = {
                ...formData,
                companyId: user.company.id,
                startDate: formData.isLimitedTime ? formData.startDate : null,
                endDate: formData.isLimitedTime ? formData.endDate : null,
            };

            await RequestService.updateQuiz(quizId, payload);
            onSuccess('Quiz atualizado com sucesso!');
            onClose();
        } catch {
            alert('Erro ao atualizar quiz.');
        }
    };

    if (!open || loading || !formData) return null;

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>Editar Quiz</DialogTitle>
            <DialogContent>
                <Stepper
                    activeStep={activeStep}
                    alternativeLabel
                    sx={{ mb: 2 }}
                >
                    {steps.map((label) => (
                        <Step key={label}>
                            <StepLabel>{label}</StepLabel>
                        </Step>
                    ))}
                </Stepper>
                <QuizForm
                    formData={formData}
                    setFormData={setFormData}
                    activeStep={activeStep}
                    user={user}
                    games={games}
                    groups={groups}
                />
            </DialogContent>
            <DialogActions>
                {activeStep > 0 && (
                    <Button onClick={() => setActiveStep((s) => s - 1)}>
                        Voltar
                    </Button>
                )}
                {activeStep < steps.length - 1 ? (
                    <Button onClick={() => setActiveStep((s) => s + 1)}>
                        Próximo
                    </Button>
                ) : (
                    <Button variant="contained" onClick={handleSubmit}>
                        Salvar Alterações
                    </Button>
                )}
                <Button onClick={onClose}>Cancelar</Button>
            </DialogActions>
        </Dialog>
    );
};

export default EditQuizDialog;
